module.exports = __webpack_public_path__ + "static/media/use-case-5.1d520478.jpg";